import { FILTER_KEYS, SORT_DIRECTION as DIRECTION } from 'store/browse-items/fixtures';
import { FILTER_KEYS as BARCODE_FILTER_KEYS, SORT_DIRECTION as BARCODE_DIRECTION } from 'store/barcode-items/fixtures';
import {
  BARCODE_SORTING_VALUES,
  SORTING_VALUES,
  SORTING,
} from './constants';

const {
  SORT_BY,
  SORT_DIRECTION,
  QUANTITY,
} = FILTER_KEYS;

// to be reworked when sort options amount is increased
export const getFilterValues = ({ field, value }) => {
  const result = {};

  if (field === SORT_BY) {
    Object.assign(result, SORTING_VALUES[value]);
  } else if (field === QUANTITY) {
    result[field] = value;
  } else {
    result[field] = value;
  }

  return result;
};

export const getBarcodeFilterValues = ({ field, value }) => {
  const result = {};

  if (field === DIRECTION.NAME) {
    Object.assign(result, BARCODE_SORTING_VALUES[value]);
  } else {
    result[field] = value;
  }

  return result;
};

export const getSortingValue = (config) => {
  if (config[SORT_DIRECTION] === DIRECTION.NAME) {
    return SORTING.NAME;
  }

  if (config[SORT_DIRECTION] === DIRECTION.MOST_LIKED) {
    return SORTING.MOST_LIKED;
  }

  if (config[SORT_DIRECTION] === DIRECTION.CATEGORY) {
    return SORTING.CATEGORY;
  }

  if (config[SORT_DIRECTION] === DIRECTION.MANUFACTURER) {
    return SORTING.MANUFACTURER;
  }

  if (config[SORT_DIRECTION] === DIRECTION.DESC) {
    return SORTING.RECENT;
  }
  if (config[SORT_DIRECTION] === DIRECTION.STORAGE) {
    return SORTING.STORAGE;
  }

  return SORTING.OLDEST;
};

export const getBarcodeSortingValue = (config) => {
  if (config[BARCODE_FILTER_KEYS.SORT_DIRECTION] === BARCODE_DIRECTION.NAME) {
    return BARCODE_DIRECTION.NAME;
  }

  if (config[BARCODE_FILTER_KEYS.SORT_DIRECTION] === BARCODE_DIRECTION.CATEGORY) {
    return BARCODE_DIRECTION.CATEGORY;
  }

  if (config[BARCODE_FILTER_KEYS.SORT_DIRECTION] === BARCODE_DIRECTION.MANUFACTURER) {
    return BARCODE_DIRECTION.MANUFACTURER;
  }

  return BARCODE_DIRECTION.DESC;
};
